import { MenuItemType } from '@/components/Menu/types'
import { PATHS_WITH_SECTIONS } from '@/router/RoutesUtils'
import { NavigationTestIds } from 'automation/playwright/test-ids/navigation-testid'
import { ReactNode } from 'react'
import MembersDirectoryIcon from '@/components/Icons/MembersDirectoryIcon'
import MyReferralNetworkIcon from '@/components/Icons/MyReferralNetworkIcon'
import WaterfallReferralsIcon from '@/components/Icons/WaterfallReferralsIcon'
import { CallToAction } from '../MemberDirectory/components/CallToAction'

// Define a more flexible navigation structure with routes and metadata
export interface MyNetworkNavItemType {
  id: 'waterfall-referrals' | 'member-directory' | 'my-private-network' // Unique identifier used for routes and keys
  label: string // Display label for the menu
  title: string // Page title
  subtitle: string // Page subtitle/description
  route: string // URL path fragment (without base path)
  testid?: string // Optional data-testid for automation tests
  icon?: ReactNode
}

// Collection of all navigation items
export const MY_NETWORK_NAV_ITEMS: MyNetworkNavItemType[] = [
  {
    id: 'my-private-network',
    label: 'My Private Network',
    route: 'my-private-network',
    title: 'My Private Network',
    subtitle: 'Create a private network and auto-route cases to them.',
    testid: NavigationTestIds.myReferralNetworkLink,
    icon: <MyReferralNetworkIcon />,
  },
  {
    id: 'waterfall-referrals',
    label: 'Waterfall Referrals™',
    route: 'waterfall-referrals',
    title: 'Waterfall Referrals™',
    subtitle: '',
    testid: NavigationTestIds.waterfallLink,
    icon: <WaterfallReferralsIcon />,
  },
  {
    id: 'member-directory',
    label: 'Member Directory',
    route: 'member-directory',
    title: 'Member Directory',
    subtitle: `Search for members who are already in your network or discover attorneys who are part of Attorney Share.`,
    testid: NavigationTestIds.memberDirectoryLink,
    icon: <MembersDirectoryIcon />,
  },
]

// Helper functions for the new navigation system
export const getNavItemById = (
  id: MyNetworkNavItemType['id']
): MyNetworkNavItemType | undefined =>
  MY_NETWORK_NAV_ITEMS.find(item => item.id === id)

export const getNavItemByRoute = (
  route: MyNetworkNavItemType['route']
): MyNetworkNavItemType | undefined =>
  MY_NETWORK_NAV_ITEMS.find(item => item.route === route)

export const getCallToAction = (route: string) => {
  const page = getNavItemByRoute(route)

  if (!page) return null

  switch (page.id) {
    case 'member-directory': {
      return <CallToAction />
    }
    default: {
      return null
    }
  }
}

export const getFullRoute = (item: MyNetworkNavItemType): string =>
  `${PATHS_WITH_SECTIONS.MY_NETWORK}/${item.route}`
// Get default navigation item (first in the list)
export const getDefaultNavItem = (): MyNetworkNavItemType =>
  MY_NETWORK_NAV_ITEMS[0]

// Format the menu items for the sidebar navigation
export const menuItems: MenuItemType[] = [
  {
    sectionTitle: '',
    items: MY_NETWORK_NAV_ITEMS.map(item => ({
      label: item.label,
      path: item.route,
      testid: item.testid,
      icon: item.icon,
    })),
  },
]

export const getMyNetworkFirstLink = () =>
  `${PATHS_WITH_SECTIONS.MY_NETWORK}/${MY_NETWORK_NAV_ITEMS[0].route}`
